import { render, staticRenderFns } from "./ConsultationInMinimalRoom.vue?vue&type=template&id=241803f0&"
import script from "./ConsultationInMinimalRoom.vue?vue&type=script&lang=js&"
export * from "./ConsultationInMinimalRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports